import api from './AxiosInstance';

export class FournissDiversService {
  getAllFournissDivers = async () => {
    try {
      const response = await api.get(`/PlanCompta/FournDiv/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };


  addFournissDivers= async ( newPrestation) => {
    try {
    
  
      const response = await api.post(`/PlanCompta/FournDiv/add`, newPrestation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  updateFournissDivers= async ( updatedPrestation) => {
    try {
     

      const response = await api.put(`/PlanCompta/FournDiv/Update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deleteFournissDivers= async ( prestationId) => {
    try {
    
      const response = await api.delete(`/PlanCompta/delete/${prestationId}`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
}


